import { useState } from "react";
import { Button } from "../../elements/Button";
import buttoncss from "../../css/button.module.css";
import icrCss from "../../css/interCompanyEliminations.module.css";
import { ReactComponent as ExportWhite } from "../../assets/icons/exportWhite.svg"
import { ReactComponent as InfoPrimaryIcon } from "../../assets/icons/infoPrimary.svg"
import { ReactComponent as LeftArrowIcon } from "../../assets/icons/left_arrow.svg"
import { ReactComponent as DotIcon } from "../../assets/icons/dot.svg"
import { ReactComponent as FilterIcon } from "../../assets/icons/filter.svg"
import ColorInfoModal from "./ColorInfoModal";
import FilterModal from "./FilterModal";

export const filterOptions = [
	{
		"name": "My User",
		"type": "people",
		"fieldType": "Custom",
		"key": "68da6c4a4b78aec1ee742624",
		"filterTypes": [
			"include",
			"exclude"
		]
	},
	{
		"name": "My Tags",
		"type": "tag",
		"fieldType": "Custom",
		"key": "68db6813d3413bfab6cfb00f",
		"filterTypes": [
			"contains",
			"starts with",
			"does not contain"
		]
	},
	{
		"name": "Assignee",
		"type": "people",
		"fieldType": "Default",
		"key": "assigneeIDs",
		"filterTypes": [
			"include",
			"exclude"
		]
	},
	{
		"name": "Approver",
		"type": "people",
		"fieldType": "Default",
		"key": "approverID",
		"filterTypes": [
			"include",
			"exclude"
		]
	},
	{
		"name": "Module",
		"type": "shortText",
		"fieldType": "Default",
		"key": "module",
		"filterTypes": [
			"contains",
			"starts with",
			"does not contain"
		]
	},
	{
		"name": "Due Date",
		"type": "date",
		"fieldType": "Default",
		"key": "dueDate",
		"filterTypes": [
			"less than",
			"equal to",
			"greater than"
		]
	},
	{
		"name": "Status",
		"type": "shortText",
		"fieldType": "Default",
		"key": "status",
		"filterTypes": [
			"contains",
			"starts with",
			"does not contain"
		]
	}
]

const ViewReconciliation = ({ setEliminationScreen }) => {

    const invoiceData = [
        { invoiceNumber: "INV-1003", date: "11 July 2025", amount: 15300, entry: "Fully" },
        { invoiceNumber: "INV-1007", date: "21 July 2025", amount: 8750, entry: "Fully" },
        { invoiceNumber: "INV-1009", date: "26 July 2025", amount: 21500, entry: "Fully" },
        { invoiceNumber: "INV-1012", date: "3 August 2025", amount: 17800, entry: "Fully" },
        { invoiceNumber: "INV-1014", date: "10 August 2025", amount: 11800, entry: "Fully" },
        { invoiceNumber: "INV-1002", date: "9 July 2025", amount: 8420, entry: "Partial" },
        { invoiceNumber: "INV-1006", date: "18 July 2025", amount: 10200, entry: "Partial" },
        { invoiceNumber: "INV-1010", date: "29 July 2025", amount: 9650, entry: "Partial" },
        { invoiceNumber: "INV-1015", date: "10 August 2025", amount: 12450, entry: "Partial" },
        { invoiceNumber: "INV-1004", date: "14 July 2025", amount: 6780, entry: "No Match" },
        { invoiceNumber: "INV-1008", date: "23 July 2025", amount: 14780, entry: "No Match" },
        { invoiceNumber: "INV-1013", date: "5 August 2025", amount: 11290, entry: "No Match" },
    ];

    const [ colorModal, setColorModal ] = useState(false)
    const [filterModalOpen, setFilterModalOpen] = useState(false)

    const CloseColorModal = () => {
        setColorModal(false)
    }

    const handleFilterModalClose = () => {
		setFilterModalOpen(false)
	}

    return (
        <>
            <div className={icrCss.header}>
                <div style={{ display: "flex", alignItems: "center", gap: "15px", fontSize: "14px" }}>
                    <span style={{ cursor: "pointer" }} onClick={() => setEliminationScreen(0)}>
                        <span>
                            <LeftArrowIcon height={12} style={{ marginBottom: "2px" }} />
                        </span>
                        <span style={{ color: "#4D6D64", marginLeft: "10px" }}>
                            Inter company elimination
                        </span>
                    </span>
                    <span>
                        <DotIcon />
                    </span>
                    <span style={{ color: "#4D6D64", cursor: "pointer" }} onClick={() => setEliminationScreen(1)}>View workings</span>
                    <span>
                        <DotIcon />
                    </span>
                    <span style={{ color: "#4D6D64", cursor: "pointer" }} onClick={() => setEliminationScreen(2)}>Perform reconciliation</span>
                    <span>
                        <DotIcon />
                    </span>
                    <span>View reconciliation</span>
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: "15px", fontSize: "10px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "3px", fontSize: "14px", color:"#2D8861", cursor:"pointer" }} onClick={()=> setColorModal(true)}>
                        <InfoPrimaryIcon  height={16}/>
                        What are these colors?
                    </div>
                    <FilterIcon style={{ cursor:"pointer" }} onClick={() => setFilterModalOpen(true)} />
                    <Button
                        icon={<ExportWhite height={16} />}
                        btnColor={buttoncss.primary}
                        label="Export"
                    />
                </div>
            </div>
            <div className={icrCss.reconciliationPanelCtn}>
                <div className={icrCss.reconciliationPanel}>
                    <div className={icrCss.reconciliationPanelHeader}>
                        <label>In the Books of</label>
                        <div>Volkswagen Automobiles LLC</div>
                    </div>
                    <div className={icrCss.reconciliationPanelSubHeader}>
                        <label>Transaction/Balances</label>
                        <div className={icrCss.reconciliationBubbleCtn}>
                            <span className={icrCss.reconciliationBubble}>Sale of goods</span>
                            <span className={icrCss.reconciliationBubble}>Sale of goods</span>
                            <span className={icrCss.reconciliationBubble}>Sale of goods</span>
                        </div>
                    </div>
                    <div style={{ padding:"5px 10px" }}>
                        <div className={icrCss.reconciliationTableCtn}>
                            <table className={icrCss.reconciliationTable}>
                                <thead>
                                    <tr>
                                        <th style={{ textAlign:"left" }}>Invoice number</th>
                                        <th style={{ textAlign:"left" }}>date</th>
                                        <th style={{ textAlign:"right" }}>amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {invoiceData.map((item, index) => {

                                        const entryClass =
                                            item.entry === "Fully"
                                                ? "matchedEntry"
                                                : item.entry === "Partial"
                                                ? "partialMatchedEntry"
                                                : "";

                                        return (
                                            <tr key={index} className={icrCss[entryClass] || ""}>
                                                <td style={{ textAlign:"left" }}>{item.invoiceNumber}</td>
                                                <td style={{ textAlign:"left" }}>{item.date}</td>
                                                <td style={{ textAlign:"right" }}>{item.amount.toLocaleString()}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className={icrCss.reconciliationPanel}>
                    <div className={icrCss.reconciliationPanelHeader}>
                        <label>In the Books of</label>
                        <div>Lendio Corporation Ltd</div>
                    </div>
                    <div className={icrCss.reconciliationPanelSubHeader}>
                        <label>Transaction/Balances</label>
                        <div className={icrCss.reconciliationBubbleCtn}>
                            <span className={icrCss.reconciliationBubble}>Sale of goods</span>
                            <span className={icrCss.reconciliationBubble}>Sale of goods</span>
                            <span className={icrCss.reconciliationBubble}>Sale of goods</span>
                        </div>
                    </div>
                    <div style={{ padding:"5px 10px" }}>
                        <div className={icrCss.reconciliationTableCtn}>
                            <table className={icrCss.reconciliationTable}>
                                <thead>
                                    <tr>
                                        <th style={{ textAlign:"left" }}>Invoice number</th>
                                        <th style={{ textAlign:"left" }}>date</th>
                                        <th style={{ textAlign:"right" }}>amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {invoiceData.map((item, index) => {

                                        const entryClass =
                                            item.entry === "Fully"
                                                ? "matchedEntry"
                                                : item.entry === "Partial"
                                                ? "partialMatchedEntry"
                                                : "";

                                        return (
                                            <tr key={index} className={icrCss[entryClass] || ""}>
                                                <td style={{ textAlign:"left" }}>{item.invoiceNumber}</td>
                                                <td style={{ textAlign:"left" }}>{item.date}</td>
                                                <td style={{ textAlign:"right" }}>{item.amount.toLocaleString()}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {colorModal && (
                <ColorInfoModal 
                    handleClose={CloseColorModal}
                />
            )}

            {filterModalOpen && (
                <FilterModal 
                    filterAttr={filterOptions}
                    handleClose={handleFilterModalClose}
                />
            )}
        </>
    )
}

export default ViewReconciliation;